import { render, staticRenderFns } from "./ballRoomList.vue?vue&type=template&id=fb731974&scoped=true"
import script from "./ballRoomList.vue?vue&type=script&lang=ts"
export * from "./ballRoomList.vue?vue&type=script&lang=ts"
import style0 from "./ballRoomList.vue?vue&type=style&index=0&id=fb731974&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb731974",
  null
  
)

export default component.exports